/**
 * ! ATENÇÃO
 *
 * se o seu component for pesado, e utiliza biblioteca de terceiros, export da forma abaixo:
 *
 * @example export const MyAsyncComponent = defineAsyncComponent(() => import("./MyAsyncComponent.vue"))
 */

import { defineAsyncComponent } from "vue"

// Atoms físicos nesta pasta
export { default as TextPlay } from "./TextPlay/TextPlay.vue"
export { default as InputPlayV3 } from "./InputPlayV3/InputPlayV3.vue"
export { default as TextareaPlayV2 } from "./TextareaPlayV2/TextareaPlayV2.vue"
export { default as InputRadioPlay } from "./InputRadioPlay/InputRadioPlay.vue"
export { default as InputRangePlay } from "./InputRangePlay/InputRangePlay.vue"
export { default as CheckboxPlay } from "./CheckboxPlay/CheckboxPlay.vue"
export { default as ProgressBarPlay } from "./ProgressBarPlay/ProgressBarPlay.vue"
export { default as BadgePlay } from "./BadgePlay/BadgePlay.vue"
export { default as AvatarPlay } from "./AvatarPlay/AvatarPlay.vue"
export { default as DividerPlay } from "./DividerPlay/DividerPlay.vue"
export { default as InfiniteScrollPlay } from "./InfiniteScrollPlay/InfiniteScrollPlay.vue"
export { default as ToggleButtonPlay } from "./ToggleButtonPlay/ToggleButtonPlay.vue"
export { default as InputColorPlay } from "./InputColorPlay/InputColorPlay.vue"
export { default as BoxPlay } from "./BoxPlay/BoxPlay.vue"



export const IconGoogle = defineAsyncComponent(() => import("./IconGoogle/IconGoogle.vue"))

// Re-exports de outros locations
export { default as CollapsePlay } from "./CollapsePlay/CollapsePlay.vue"
export { default as FileIconPlay } from "./FileIconPlay/FileIconPlay.vue"
export { default as SpinnerPlay } from "./SpinnerPlay/SpinnerPlay.vue"
export { default as Loading } from "./SpinnerPlay/SpinnerPlay.vue"
export { default as Radio } from "@/components/common/RadioInput/RadioInput.vue"
export { default as TutorIcon } from "@/components/common/TutorIcon/TutorIcon.vue"

/**
 * Layout
 */
export const SidePanel = defineAsyncComponent(() => import("@/layouts/SidePanel.vue"))

export const Swiper = defineAsyncComponent(() => import("swiper/vue").then(module => module.Swiper));
export const SwiperSlide = defineAsyncComponent(() => import("swiper/vue").then(module => module.SwiperSlide));
